import React from "react";

import { faBan, faCheck, faHourglass, faTruck } from "@fortawesome/pro-regular-svg-icons";
import { COLORS } from "rylak-common/src/constants";
import { SHIPMENT_DELIVERY_STATUS } from "~/constants";
import { CHIP_COLOR_TYPES, ChipTooltip } from "../CustomChip.jsx";
import { EntityActionStatusChipDeprecated } from "../../entityAction/EntityActionStatusChip.jsx";

function Tooltip({ label } = {}) {
    return (
        <ChipTooltip
            title={
                <div>
                    <span style={{ color: COLORS.WEAK_TEXT }}>Delivery Status - </span>
                    {label}
                </div>
            }
        />
    );
}

export const SHIPMENT_BOOKING_STATUS_MAP = {
    [SHIPMENT_DELIVERY_STATUS.AWAITING_COLLECT]: {
        colorType: CHIP_COLOR_TYPES.OK,
        label: "Awaiting pickup/hand-in",
        icon: faHourglass,
        selectable: false,
        tooltipTitleFn: Tooltip,
    },
    [SHIPMENT_DELIVERY_STATUS.IN_TRANSIT]: {
        colorType: CHIP_COLOR_TYPES.OK,
        label: "In transit",
        icon: faTruck,
        selectable: false,
        tooltipTitleFn: Tooltip,
    },
    [SHIPMENT_DELIVERY_STATUS.DELIVERED]: {
        colorType: CHIP_COLOR_TYPES.DONE,
        label: "Delivered",
        icon: faCheck,
        selectable: true,
        tooltipTitleFn: Tooltip,
    },
    [SHIPMENT_DELIVERY_STATUS.CANCELLED]: {
        colorType: CHIP_COLOR_TYPES.DONE,
        label: "Cancelled",
        icon: faBan,
        selectable: true,
        tooltipTitleFn: Tooltip,
    },
};

export function ShipmentDeliveryStatusChip(props) {
    return <EntityActionStatusChipDeprecated statusData={SHIPMENT_BOOKING_STATUS_MAP[props.status]} {...props} />;
}
